import { CrmSegment } from '../CrmSegment.enum';

const filters = [
  {
    label: 'Subscribed',
    value: CrmSegment.Subscribed,
  },
  {
    label: 'One-Time Purchases',
    value: CrmSegment.ExclusiveBuyers,
  },
  {
    label: 'Free Offers',
    value: CrmSegment.FreeOffers,
  },
  {
    label: 'Leads',
    value: CrmSegment.Leads,
  },
  {
    label: 'Abandoned Carts',
    value: CrmSegment.AbandonedCarts,
  },
];

export type CrmFilterProps = {
  activeFilter: CrmSegment | null;
  setActiveFilter: (filter: CrmSegment | null) => void;
  allowedSegments: CrmSegment[];
};

export const CrmSegmentSelect = ({
  activeFilter,
  setActiveFilter,
  allowedSegments,
}: CrmFilterProps) => {
  const visibleFilters = filters.filter((f) =>
    allowedSegments.includes(f.value),
  );

  return (
    <div className="flex items-center gap-2">
      {visibleFilters.map((filter) => {
        const isActive = filter.value == activeFilter;
        return (
          <button
            key={filter.value}
            className={`flex items-center  ${
              isActive ? 'bg-zinc-700 text-white' : 'bg-white text-zinc-900'
            } rounded-full px-4 py-2 text-sm  font-semibold `}
            onClick={() =>
              isActive ? setActiveFilter(null) : setActiveFilter(filter.value)
            }
          >
            <span>{filter.label}</span>
          </button>
        );
      })}
    </div>
  );
};
